import PropTypes from "prop-types";
import {
  BotaoVoltar,
  Card,
  CardContent,
  CardHeader,
  Loading
} from "../../../../../components";
import "../../../../../layouts/minimal/minimal-layout.scss";

const MinimalCustomLayout = ({
  children,
  loading,
  ButtonMenu,
  title,
  cardAction,
  action,
  filterActions,
}) => {
  return (
    <div className="minimal-layout-container">
      {ButtonMenu && (
        <div className="d-flex flex justify-content-start">
          <Card className="px-3 py-3 mb-2 d-flex align-items-center w-100">
            <BotaoVoltar />
            <div>{ButtonMenu}</div>
          </Card>
        </div>
      )}

      <Card className="minimal-layout-card">
        <CardHeader title={title} botaoVoltar={!ButtonMenu} action={action} filterActions={filterActions}/>

        <CardContent className="minimal-layout-card-content rolagem">
          {children}
        </CardContent>

        {cardAction && <div className="minimal-card-actions">{cardAction}</div>}
      </Card>

      <Loading loading={loading} />
    </div>
  );
};

MinimalCustomLayout.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  ButtonMenu: PropTypes.node,
  title: PropTypes.string,
  cardAction: PropTypes.node,
};

export default MinimalCustomLayout;
